<template>
  <section class="command">
    <div class="command-copy">
      <span class="eyebrow">Private Preview</span>
      <h1>后室层级探索，与领地占领。</h1>
      <p>以档案方式浏览所有层级，通过随机探索进入可互动状态。占领、留言与守护只在随机探索路径中开放。</p>
      <a class="command-guide-link" href="#" @click.prevent="$emit('random')">
        点击随机探索可以抢占层级，然后按自己的心意修改对应层级的内容
      </a>
      <div class="command-actions">
        <el-button type="primary" size="large" :icon="Aim" @click="$emit('random')">随机探索</el-button>
        <el-button class="refresh-archive-btn" size="large" :icon="Refresh" @click="$emit('refresh')">刷新档案</el-button>
      </div>
    </div>

    <aside class="status-board">
      <div class="board-row">
        <span>档案层级</span>
        <strong>{{ archiveCount }}</strong>
      </div>
      <button class="board-row board-row-action summary-board-row" type="button" @click="$emit('openMine')">
        <span>我的层级</span>
        <strong>{{ mineCount }}</strong>
      </button>
      <button class="board-row board-row-action summary-board-row" type="button" @click="$emit('openFavorites')">
        <span>收藏层级</span>
        <strong>{{ favoriteCount }}</strong>
      </button>
      <button class="board-row board-row-action visit-board-row" type="button" @click="$emit('visit-stats')">
        <span>今日访问量:</span>
        <strong>{{ visitSummary.loading ? '--' : formatStat(visitSummary.todayVisits) }}</strong>
      </button>
      <div class="board-note">Archive is read-only. Random exploration enables interaction.</div>
    </aside>
  </section>
</template>

<script setup lang="ts">
import { Aim, Refresh } from '@element-plus/icons-vue';

type VisitSummary = {
  visible: boolean;
  loading: boolean;
  todayVisitors: number;
  todayVisits: number;
  weekVisits: number;
  monthVisitors: number;
  monthVisits: number;
};

defineProps<{
  archiveCount: number;
  mineCount: number;
  favoriteCount: number;
  visitSummary: VisitSummary;
}>();

defineEmits<{
  (e: 'random'): void;
  (e: 'refresh'): void;
  (e: 'visit-stats'): void;
  (e: 'openMine'): void;
  (e: 'openFavorites'): void;
}>();

const formatStat = (value: number) => Number(value || 0).toLocaleString('zh-CN');
</script>
